import { ConciergeMessageType } from "./ConciergeMessageType";
import type { IConciergeMessage, IConciergeMessageDto } from "./IConciergeMessage";

export class ConciergeMessage implements IConciergeMessage
{

    conciergeMessageId: string;
    content: string;
    type: ConciergeMessageType;

    constructor( model: IConciergeMessageDto )
    {
        this.conciergeMessageId = model.conciergeMessageId;
        this.content = model.content;
        this.type = model.type;
    }

    /**
     * True if the message has a link
     */
    get hasLink()
    {
        return this.type != ConciergeMessageType.None;
    }

    /**
     * Gets the link URL for the message
     */
    get linkUrl()
    {
        switch( this.type )
        {
            case ConciergeMessageType.CarbucksProfile:
                return '/carbucks';
            default:
                return '';
        }
    }

}